// extracted by mini-css-extract-plugin
export default {"container":"LimitedTimePaywall_container__Ex2a3","top":"LimitedTimePaywall_top__5HdUe","bottom":"LimitedTimePaywall_bottom__uw1oL"};